































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: { Icon },
  props: {
    color: String,
    header: String,
    message: String,
    icon: String,
    special: {
      type: Boolean,
      default: false
    }
  }
})
export default class Notification extends Vue {
  get formattedMessage () {
    return this.$props.message ? this.$props.message.replace(/\n/g, '<br>') : ''
  }
}
